<template>
	<div
		v-if="node.type === 'page'"
		:id="node.id"
		:data-key="node.key"
		:style="getPageStyle(node)"
		class="content-editor">
		<div
			:class="{
				'content-editor--slim': pageLayout === 'slim'
			}"
			:style="innerStyle">
			<template v-if="node.children && node.children.length">
				<draggable
					:list="node.children"
					:animation="200"
					@start="onDragContainer"
					@end="onEndDragContainer"
					handle=".container-handle">
					<NodeTree
						v-for="(child, i) in node.children"
						:node="child"
						:key="i"
						:onPreview="onPreview"
						:settings="settings"
						:previewDevice.sync="previewDevice"
					/>
				</draggable>
			</template>
		</div>
	</div>

	<!-- <div
		v-for="(item, index) in nodes"
		:key="index"
		v-else-if="item.type === node.type">
	</div> -->
	<!-- <component
		v-for="(item, index) in nodes"
		:key="index"
		v-else-if="item.type === node.type"
		:is="item.component"
	/> -->

	<NodeNavigation
		v-else-if="node.type === 'nav'"
		:node.sync="node"
		:onPreview="onPreview"
		:previewDevice.sync="previewDevice"
		:settings="settings" />
	<NodeContainer
		v-else-if="node.type === 'container'"
		:key="node.id"
		:node.sync="node"
		:onPreview="onPreview"
		:previewDevice.sync="previewDevice"
		:settings="settings"
	/>
	<NodeRow
		v-else-if="node.type === 'row'"
		:node.sync="node"
		:onPreview="onPreview"
		:previewDevice.sync="previewDevice"
		:rowLength="2"
		:settings="settings"
	/>
	<NodeCol v-else-if="node.type === 'col'" :key="node.id" :node.sync="node" :onPreview="onPreview" :previewDevice.sync="previewDevice" :settings="settings"/>
	<NodeHeading v-else-if="node.type === 'heading'" :key="node.id" :node.sync="node" :onPreview="onPreview" :previewDevice.sync="previewDevice" :settings="settings" />
	<NodeParagraph v-else-if="node.type === 'paragraph'" :key="node.id" :node.sync="node" :onPreview="onPreview" :previewDevice.sync="previewDevice" :settings="settings" />
	<NodeImage v-else-if="node.type === 'image'" :key="node.id" :node.sync="node" :onPreview="onPreview" :previewDevice.sync="previewDevice" :settings="settings" />
	<NodeVideo v-else-if="node.type === 'video'" :key="node.id" :node.sync="node" :onPreview="onPreview" :previewDevice.sync="previewDevice" :settings="settings" />
	<NodeForm v-else-if="node.type === 'form'" :key="node.id" :node.sync="node" :onPreview="onPreview" :previewDevice.sync="previewDevice" :settings="settings" />
	<NodeButton v-else-if="node.type === 'button'" :key="node.id" :node.sync="node" :onPreview="onPreview" :previewDevice.sync="previewDevice" :settings="settings" />
	<NodeLink v-else-if="node.type === 'link'" :key="node.id" :node.sync="node" :onPreview="onPreview" :previewDevice.sync="previewDevice" :settings="settings" />
	<NodeDivider v-else-if="node.type === 'divider'" :key="node.id" :node.sync="node" :onPreview="onPreview" :previewDevice.sync="previewDevice" :settings="settings" />
	<NodeList v-else-if="node.type === 'list'" :key="node.id" :node.sync="node" :onPreview="onPreview" :previewDevice.sync="previewDevice" :settings="settings" />
	<NodeCarousel v-else-if="node.type === 'carousel'" :key="node.id" :node.sync="node" :onPreview="onPreview" :previewDevice.sync="previewDevice" :settings="settings" />
	<NodeSlider v-else-if="node.type === 'slider'" :key="node.id" :node.sync="node" :onPreview="onPreview" :previewDevice.sync="previewDevice" :settings="settings" />
	<NodeQuote v-else-if="node.type === 'quote'" :key="node.id" :node.sync="node" :onPreview="onPreview" :previewDevice.sync="previewDevice" :settings="settings" />
	<NodeImageBox v-else-if="node.type === 'image_box'" :key="node.id" :node.sync="node" :onPreview="onPreview" :previewDevice.sync="previewDevice" :settings="settings" />
	<NodeButtonWa v-else-if="node.type === 'whatsapp'" :key="node.id" :node.sync="node" :onPreview="onPreview" :previewDevice.sync="previewDevice" :settings="settings" />
	<NodePricing v-else-if="node.type === 'pricing'" :key="node.id" :node.sync="node" :onPreview="onPreview" :previewDevice.sync="previewDevice" :settings="settings" />
	<NodeCountdown v-else-if="node.type === 'countdown'" :key="node.id" :node.sync="node" :onPreview="onPreview" :previewDevice.sync="previewDevice" :settings="settings" />
	<NodeAccordion v-else-if="node.type === 'accordion'" :key="node.id" :node.sync="node" :onPreview="onPreview" :previewDevice.sync="previewDevice" :settings="settings" />
	<NodeStockCounter v-else-if="node.type === 'stock_counter'" :key="node.id" :node.sync="node" :onPreview="onPreview" :previewDevice.sync="previewDevice" :settings="settings" />
	<NodeAnchor v-else-if="node.type === 'anchor'" :key="node.id" :node.sync="node" :onPreview="onPreview" :previewDevice.sync="previewDevice" :settings="settings" />
	<NodeHtml v-else-if="node.type === 'html'" :key="node.id" :node.sync="node" :onPreview="onPreview" :previewDevice.sync="previewDevice" :settings="settings" />

	<div v-else :class="node.class" :id="node.id" :data-key="node.key">
		<template v-if="node.children && node.children.length">
			<NodeTree
				v-for="(child, i) in node.children"
				:node="child"
				:mainNode="node"
				:key="i"
				:onPreview="onPreview"
				:previewDevice.sync="previewDevice"
				:settings="settings"
			/>
		</template>
		<template v-else>
			{{ node.options && node.options.content }}
		</template>
	</div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import draggable from 'vuedraggable';
import {
	// eslint-disable-next-line
	getRgbaColor,
	rgbToHex,
	// eslint-disable-next-line
} from '@/lib/helper';

import NodeContainer from '@/components/funnels/pagebuilder/nodes/NodeContainer.vue';
import NodeRow from '@/components/funnels/pagebuilder/nodes/NodeRow.vue';
import NodeCol from '@/components/funnels/pagebuilder/nodes/NodeCol.vue';
import NodeHeading from '@/components/funnels/pagebuilder/nodes/NodeHeading.vue';
import NodeParagraph from '@/components/funnels/pagebuilder/nodes/NodeParagraph.vue';
import NodeImage from '@/components/funnels/pagebuilder/nodes/NodeImage.vue';
import NodeVideo from '@/components/funnels/pagebuilder/nodes/NodeVideo.vue';
import NodeForm from '@/components/funnels/pagebuilder/nodes/NodeForm.vue';
import NodeButton from '@/components/funnels/pagebuilder/nodes/NodeButton.vue';
import NodeDivider from '@/components/funnels/pagebuilder/nodes/NodeDivider.vue';
import NodeLink from '@/components/funnels/pagebuilder/nodes/NodeLink.vue';
import NodeList from '@/components/funnels/pagebuilder/nodes/NodeList.vue';
import NodeNavigation from '@/components/funnels/pagebuilder/nodes/NodeNavigation.vue';
import NodeCarousel from '@/components/funnels/pagebuilder/nodes/NodeCarousel.vue';
import NodeSlider from '@/components/funnels/pagebuilder/nodes/NodeSlider.vue';
import NodeQuote from '@/components/funnels/pagebuilder/nodes/NodeQuote.vue';
import NodeImageBox from '@/components/funnels/pagebuilder/nodes/NodeImageBox.vue';
import NodeButtonWa from '@/components/funnels/pagebuilder/nodes/NodeButtonWa.vue';
import NodePricing from '@/components/funnels/pagebuilder/nodes/NodePricing.vue';
import NodeCountdown from '@/components/funnels/pagebuilder/nodes/NodeCountdown.vue';
import NodeAccordion from '@/components/funnels/pagebuilder/nodes/NodeAccordion.vue';
import NodeStockCounter from '@/components/funnels/pagebuilder/nodes/NodeStockCounter.vue';
import NodeAnchor from '@/components/funnels/pagebuilder/nodes/NodeAnchor.vue';
import NodeHtml from '@/components/funnels/pagebuilder/nodes/NodeHtml.vue';

const nodes = [
	{
		type: 'row',
		component: 'NodeRow',
	},
	{
		type: 'container',
		component: 'NodeContainer',
	},
	{
		type: 'col',
		component: 'NodeCol',
	},
	{
		type: 'heading',
		component: 'NodeHeading',
	},
	{
		type: 'paragraph',
		component: 'NodeParagraph',
	},
	{
		type: 'image',
		component: 'NodeImage',
	},
	{
		type: 'video',
		component: 'NodeVideo',
	},
	{
		type: 'button',
		component: 'NodeButton',
	},
	{
		type: 'divider',
		component: 'NodeDivider',
	},
	{
		type: 'link',
		component: 'NodeLink',
	},
	{
		type: 'list',
		component: 'NodeList',
	},
	{
		type: 'nav',
		component: 'NodeNavigation',
	},
	{
		type: 'carousel',
		component: 'NodeCarousel',
	},
	{
		type: 'slider',
		component: 'NodeSlider',
	},
	{
		type: 'quote',
		component: 'NodeQuote',
	},
	{
		type: 'image_box',
		component: 'NodeImageBox',
	},
	{
		type: 'whatsapp',
		component: 'NodeButtonWa',
	},
	{
		type: 'stock_counter',
		component: 'NodeStockCounter',
	},
	{
		type: 'pricing',
		component: 'NodePricing',
	},
	{
		type: 'countdonw',
		component: 'NodeCountdown',
	},
	{
		type: 'accordion',
		component: 'NodeAccordion',
	},
];

export default {
	name: 'NodeTree',
	props: ['node', 'onPreview', 'pageId', 'previewDevice', 'settings'],
	components: {
		draggable,
		NodeContainer,
		NodeRow,
		NodeCol,
		NodeHeading,
		NodeParagraph,
		NodeImage,
		NodeVideo,
		NodeForm,
		NodeButton,
		NodeLink,
		NodeDivider,
		NodeList,
		NodeNavigation,
		NodeCarousel,
		NodeSlider,
		NodeQuote,
		NodeImageBox,
		NodeButtonWa,
		NodePricing,
		NodeCountdown,
		NodeAccordion,
		NodeStockCounter,
		NodeAnchor,
		NodeHtml,
	},
	data() {
		return {
			nodes,
		};
	},
	computed: {
		...mapGetters({
			user: 'user',
			isAdmin: 'isAdmin',
			pageHistories: 'funnels/pageHistories',
		}),
		pageLayout() {
			const layout = this.node?.options?.pageLayout || 'full';
			return layout;
		},
		innerStyle() {
			const options = this.node?.options || null;
			const style = {};
			const isPageLayoutSlim = options && options !== null && options.pageLayout && options.pageLayout === 'slim';
			if (options && options !== null && isPageLayoutSlim) {
				const { backgroundInnerColor } = options;

				style['background-color'] = backgroundInnerColor && backgroundInnerColor.rgb && backgroundInnerColor.rgb !== ''
					? getRgbaColor(backgroundInnerColor.rgb)
					: backgroundInnerColor;
			}

			return style;
		},
	},
	methods: {
		...mapActions({
			setPageEditorHistory: 'funnels/setPageEditorHistory',
			setIsDragging: 'funnels/setIsDragging',
		}),
		getPageStyle({ options }) {
			const style = {};

			if (this.onPreview) {
				style['min-height'] = '100%';
			}

			if (options) {
				const { textColor, fontFamily } = options;

				// bg color
				const isBgGradient = options && options.backgroundColorType && options.backgroundColorType === 'gradient';
				if (isBgGradient) {
					const firstColor = options.backgroundColor && options.backgroundColor.rgb && options.backgroundColor.rgb !== ''
						? rgbToHex(options.backgroundColor.rgb.r, options.backgroundColor.rgb.g, options.backgroundColor.rgb.b)
						: options.backgroundColor;
					const secondColor = options.backgroundSecondColor && options.backgroundSecondColor.rgb && options.backgroundSecondColor.rgb !== ''
						? rgbToHex(options.backgroundSecondColor.rgb.r, options.backgroundSecondColor.rgb.g, options.backgroundSecondColor.rgb.b)
						: '#fff';
					const gradientType = options && options.backgroundGradientType && options.backgroundGradientType && options.backgroundGradientType !== ''
						? options.backgroundGradientType
						: 'linear';
					// eslint-disable-next-line no-nested-ternary
					const gradientDirection = options && options.backgroundGradientDirection && options.backgroundGradientDirection && options.backgroundGradientDirection !== ''
						? gradientType === 'linear'
							? `${options.backgroundGradientDirection}deg`
							: `at ${options.backgroundGradientDirection}`
						: '';
					const gradientStart = options && options.backgroundGradientStart && options.backgroundGradientStart && options.backgroundGradientStart !== ''
						? options.backgroundGradientStart
						: 30;
					const gradientEnd = options && options.backgroundGradientEnd && options.backgroundGradientEnd && options.backgroundGradientEnd !== ''
						? options.backgroundGradientEnd
						: 100;
					const bgGradient = `${gradientType}-gradient(${gradientDirection}, ${firstColor} ${gradientStart}%, ${secondColor} ${gradientEnd}%)`;
					style['background-image'] = bgGradient;
				} else {
					style['background-color'] = options.backgroundColor && options.backgroundColor.rgb && options.backgroundColor.rgb !== ''
						? getRgbaColor(options.backgroundColor.rgb)
						: options.backgroundColor;
				}

				style.color = textColor && textColor.rgb && textColor.rgb !== ''
					? getRgbaColor(textColor.rgb)
					: textColor;
				style['font-family'] = fontFamily || '';
			}

			return style;
		},

		handleEdit(id) {
			this.$bus.$emit('edit-element', id);
		},
		handleDelete(id) {
			this.$bus.$emit('delete-element', id);
		},
		log() {
			console.log('check move');
		},
		onDragContainer() {
			console.log('container drag');
			this.setIsDragging(true);
		},
		onEndDragContainer() {
			this.setIsDragging(false);
			this.$bus.$emit('refresh-jquery', true);
			console.log('container drag end');
		},
		updateHistory(data) {
			this.$emit('update-history', data);
		},
	},
};
</script>
